import { FloatingMenu } from './floating-menu.js'

export * from './floating-menu.js'
export * from './floating-menu-plugin.js'

export default FloatingMenu
